import {
  $albumsTableSearchInputValue,
  AlbumsTable,
  AlbumsTableGate,
  albumsTableQuery,
} from '@/entities/albums'
import { ROUTES, STRINGS } from '@/shared/config'
import { EmptyContent, HidingSpin } from '@/shared/ui'
import { Button, Space } from 'antd'
import { useUnit } from 'effector-react'
import { NavLink, useNavigate } from 'react-router-dom'

import {
  $collectionsListPageLatestAlbumsFilters,
  $collectionsListPageLatestAlbumsPage,
  $collectionsListPageLatestAlbumsPageSize,
  $collectionsListPageLatestAlbumsSearch,
  $collectionsListPageLatestAlbumsSort,
  CollectionsListPageGate,
} from '../../../model/collections-list-albums-tab.model'

export const AlbumsTab = () => {
  const navigate = useNavigate()
  const { data, pending, error } = useUnit(albumsTableQuery)
  const latestSearch = useUnit($collectionsListPageLatestAlbumsSearch)
  const latestSort = useUnit($collectionsListPageLatestAlbumsSort)
  const latestFilters = useUnit($collectionsListPageLatestAlbumsFilters)
  const latestPage = useUnit($collectionsListPageLatestAlbumsPage)
  const latestPageSize = useUnit($collectionsListPageLatestAlbumsPageSize)
  const search = useUnit($albumsTableSearchInputValue)

  return (
    <>
      <CollectionsListPageGate />
      <AlbumsTableGate
        initialFilters={latestFilters}
        initialPage={latestPage}
        initialPageSize={latestPageSize}
        initialSort={latestSort}
        initialSearch={latestSearch}
      />
      <HidingSpin spinning={pending || (!data?.items && !error)}>
        {data?.items && data.items.length > 0 ? (
          <AlbumsTable
            onEdit={(albumId: string) => {
              void navigate(
                ROUTES.COLLECTIONS.EDIT_ALBUM.replace(':id', albumId),
              )
            }}
          />
        ) : search?.length && search?.length > 0 ? (
          <EmptyContent description={STRINGS.nothing_was_found} />
        ) : (
          <EmptyContent
            description="В списке пока нет ни одного альбома"
            content={
              <Space>
                <NavLink to={ROUTES.COLLECTIONS.CREATE_ALBUM}>
                  <Button>Добавить новый альбом</Button>
                </NavLink>
              </Space>
            }
          />
        )}
      </HidingSpin>
    </>
  )
}
